export const fetchIndicatorsExplanation = resp => {
  return {
    type: "FETCH_INDICATORS_EXPLANATION",
    payload: resp
  };
};
export const saveIndicatorExplanation = resp => ({
  type: "SAVE_INDICATOR_EXPLANATION",
  payload: resp
});
export const AddExplanation = explanations => {
  return {
    type: "ADD_EXPLANATION",
    explanations
  };
};
export const addExplanationContent = content => ({
  type: "ADD_EXPLANATION_CONTENT",
  content
});
export const setSelectedIndicatorExplanation = selectedIndicator => ({
  type: "SET_SELECTED_EXPLANATION",
  selectedIndicator
});
export const deleteIndicatorExplanation = resp => ({
  type: "DELETE_INDICATOR_EXPLANATION",
  payload: resp
});

export const setExplanations = explanations => {
  return {
    type: "SET_EXPLANATIONS",
    explanations
  };
};



// WEBPACK FOOTER //
// ./src/actions/actions/indicatorsExplanation.js